import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import ShipperSettings from 'components/modules/user/shipper/ShipperSettings';
import AccessorialsList from 'components/modules/user/shipper/AccessorialRequests';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';

const AccessorialRequestsPage = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState({});
  const params = useParams();
  const id = params.id;

  const fetchUser = async () => {
    const user = await getCustomerV2(id);
    setUser(user);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  function renderSidebar() {
    return <ShipperSettings activePage="accessorial-requests" userId={id} />;
  }

  const breadcrumbs = {
    pages: [
      {
        name: user.company_name || t('SHIPPER'),
        href: `/users/${id}`,
        current: false,
      },
      {
        name: t('ACCESSORIAL_REQUESTS'),
        href: `/users/${id}/settings/accessorial-requests`,
        current: true,
      },
    ],
  };
  return (
    <LayoutWithSidebar
      title={t('ACCESSORIAL_REQUESTS')}
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      <div className="w-full">
        {featureEnabled(CONFIGURED_FEATURES.SSR) && (
          <AccessorialsList id={id} />
        )}
      </div>
    </LayoutWithSidebar>
  );
};

export default AccessorialRequestsPage;
